import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const UserRoutes: RouteObject = {
	path: "/user/*",
	children: [
		{
			index: true,
			// Should be new profile page
			lazy: async () => {
				const { Profile } = await import(
					"@/components/Application/AdminMenu/Profile"
				);
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<Profile />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: "organizations/change",
			lazy: async () => {
				const { ChangeOrganization } = await import(
					"@/components/Organizations/ChangeOrganization"
				);
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<ChangeOrganization />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
	],
};
